if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalDialog {
      constructor() {
        super();
        if (document.body.classList.contains('password') || document.body.classList.contains('password-homepage-based')) {
          var opener = this.querySelector("#NewsletterPopup");
          var elementOverrides = document.querySelectorAll(".product-story-container, .multiuse-banner-section .banner__heading, a:not(.password__footer a, policy-modal a, newsletter-modal a, a.skip-to-content-link, .password-header .password-header-left-submessage a, .password-header .password-header-right-submessage a, .fake-header a), button:not(.password__footer button, policy-modal button, newsletter-modal button, .newsletter-form__button, #PolicyPopup-PasswordPrivacy-Marketing-Newsletter)");
          elementOverrides.forEach((element) =>
            element.addEventListener('click', this.elementOverrideClick.bind(this))
          );
        }
      }

      hide() {
        super.hide();
      }

      elementOverrideClick() {
        event.preventDefault();
        super.show(this.opener);
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading'); 
        super.show(opener);
      }
    }
  );
}
